import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVER_URL } from "../initalState"; // Note: Fix typo "initalState" to "initialState"

export const documentApi = createApi({
  reducerPath: "document",
  baseQuery: fetchBaseQuery({
    // baseUrl: `${SERVER_URL}/qiktrack`,
    baseUrl: `${SERVER_URL}/qiktrack`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["document"],
  endpoints: (builder) => ({
    getdocument: builder.query({
      query: ({ docTypeId, docType }) => {
        const params = { limit: "all", page: 1 };
        if (docTypeId) params.docTypeId = docTypeId;
        if (docType) params.docType = docType;
        console.log(params);
        return {
          url: `/get-document`,
          method: "GET",
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: ["document"], // Tag for cache invalidation
      keepUnusedDataFor: 0, // Add this to match get_bank_account behavior
    }),
    // Add a document
    adddocument: builder.mutation({
      query: (data) => {
        console.log(data);
        return {
          url: "/create-document",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["document"], // Invalidate cache on mutation
    }),
    updatedocument: builder.mutation({
      query: (data) => {
        return {
          url: `/update-document/${data?._id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["document"], // Invalidate cache on mutation
    }),
    deletedocument: builder.mutation({
      query: ({ id }) => ({
        url: `/delete-document/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["document"], // Invalidate cache on mutation
    }),
  }),
});

export const {
  useGetdocumentQuery,
  useAdddocumentMutation,
  useUpdatedocumentMutation,
  useDeletedocumentMutation,
} = documentApi;
